/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaSelectOneGhost from 'DesignSystem/TysiaSelectOneGhost/index'
import TysiaSelectOneGhostArrow from 'DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostArrow/index'
import TysiaSelectOneGhostContent from 'DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostContent/index'
import TysiaSelectOneGhostIcon from 'DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostIcon/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2UserSingleCircle from 'DesignSystem/Svgs/Tysiav2UserSingleCircle/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientOptions/New/AssignedDoctor/Content",
  onChange
  
}) {
let providersValueData = fromData.useDataValue({ viewPath,
context: 'providers',
})
let appointmentOverlayPatientNewProviderEmployeeResourceIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'patient_new.provider_employee_resource_id',
})
let appointmentOverlayPatientNewProviderEmployeeResourceIdChangeData = fromData.useDataChange({ viewPath,
context: 'appointment_overlay',
path: 'patient_new.provider_employee_resource_id',
})
let appointmentOverlayPatientNewProviderEmployeeResourceIdValueData1 = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'patient_new.provider_employee_resource_id',
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaSelectOneGhost
  viewPath={`${viewPath}/TysiaSelectOneGhost`}
 data="providers"
 from={providersValueData}
 data="appointment_overlay.patient_new.provider_employee_resource_id"
 value={appointmentOverlayPatientNewProviderEmployeeResourceIdValueData}
 onChange={appointmentOverlayPatientNewProviderEmployeeResourceIdChangeData}
 optionsWidth={240}
>
{childProps => (
<TysiaSelectOneGhostContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneGhostContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneGhostIcon
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneGhostIcon`}
>
{childProps => (
<Tysiav2UserSingleCircle
{...childProps}
  viewPath={`${viewPath}/Tysiav2UserSingleCircle`}
 fill2={appointmentOverlayPatientNewProviderEmployeeResourceIdValueData1 ? dtColorsNeutral900 : dtColorsNeutral400}
 data="appointment_overlay.patient_new.provider_employee_resource_id"
/>
)}
</TysiaSelectOneGhostIcon>
<TysiaSelectOneGhostArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneGhostArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<React.Fragment>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 text="Assigned doctor"
 weight="medium"
 color={dtColorsNeutral500}
 size="normal"
 marginBottom={dtSpaceXs}
 marginRight={dtSpaceXs}
 marginLeft={dtSpaceXs}
/>
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
</React.Fragment>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneGhostContent>
)}
</TysiaSelectOneGhost>
{children}
</React.Fragment>)
}